import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { sortIcons } from 'helpers/icon_helpers';

export default function DocTemplateColumnHeader({ columnConfig, sortState, onSort }) {
  const handleSort = () => {
    if (!columnConfig.sortKey) return;
    const newDirection = sortState.name === columnConfig.sortKey && sortState.direction === 'asc'
      ? 'desc'
      : 'asc';
    onSort(columnConfig.sortKey, newDirection);
  };

  const sortable = !!columnConfig.sortKey;
  let icon = sortIcons.sort;

  if (sortState.name === columnConfig.sortKey) {
    icon = sortState.direction === 'asc' ? sortIcons.alpha.asc : sortIcons.alpha.desc;
  }

  return (
    <th
      className={sortable ? 'clickable text-nowrap' : 'text-nowrap'}
      onClick={handleSort}
    >
      {columnConfig.label}
      {sortable && <FontAwesomeIcon className="ms-1" icon={icon} />}
    </th>
  );
}

DocTemplateColumnHeader.propTypes = {
  columnConfig: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    sortKey: PropTypes.string
  }).isRequired,
  sortState: PropTypes.shape({
    name: PropTypes.string.isRequired,
    direction: PropTypes.oneOf(['asc', 'desc']).isRequired
  }).isRequired,
  onSort: PropTypes.func.isRequired
};
